/* eslint-disable max-len */
/* eslint-disable arrow-body-style */
/* eslint-disable no-var */
import { Component, OnInit, Inject, Optional, ViewChild, ViewEncapsulation, ElementRef, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import moment from 'moment-business-days'; //'moment'
import { AccountService } from 'src/app/core/service/account.service';
import { Options, LabelType } from '@angular-slider/ngx-slider';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import * as financial from 'financial';
import { PriceConfirmationComponent } from '../../dashboard/inner-pages/prepay-cal/price-confirmation/price-confirmation.component';
import html2canvas from 'html2canvas';
import { FeatureFlags } from 'src/app/core/feature-flags';


export interface PayNowElement {
  days: number;
  sumOfDallies: number;
  remainingBalance: number;
  payNowBalance: number;
  totalPaid: number;
  weeksUntilPayNow: number;
  totalCostCapital: number;
  totalSavings: number;
  factor: String;
  date: String;
}

var payNowRows: PayNowElement[] = [];

@Component({
  selector: 'app-pricing-cal',
  templateUrl: './pricing-cal.component.html',
  styleUrls: ['./pricing-cal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PricingCalComponent implements OnInit {
  searchText: any;
  totalCount = -1;
  Closed = -1;
  Inprogress = -1;
  Open = -1;
  selectedOption = 'daily';
  weeklyPayment = 0;
  startingBalance = 0;
  dailyPayment = 0;
  oppId: string | undefined;
  disableCalc = false;
  term: any;
  loadingOffers = true;
  showScheduleTable = false;
  legalEstRct: any;
  offerAccepted = false;
  factor: any;
  amount: any = 5000;
  /** Raw string value of the amount input — allows empty/partial values while typing. */
  rawAmount: string = '5000';
  configs = {};
  todayDate = new Date();
  maxDate = new Date('12/31/2025');
  selectedDate = new Date();
  isMerchantFlow = false;
  isOnlineCheckout = false;
  specifiedPercentage = 0;
  calculatorMode: 'default' | 'merchant_flow' | 'loan_product' | 'merchant_loan_product' = 'default';
  showFinancialsMsg: any;
  avgDailyRev: any;
  state: any;
  productType: any;


  busName: string = '';
  /** When true, the Draw Commission slider is hidden — the ISO has disabled draw commission toggling for their reps. */
  noDrawComm = false;

  // ISO Commission Panel state
  pcntInitialLimit = 0;
  pcntDraw = 0;
  currentBaseFactor = 0;
  currentUpsellPoints = 2;
  dealCommission = 0;
  drawCommission = 0;
  calculatedFactor = 0;
  calculatedAPR: number | null = null;
  calculatedPeriodRate: number | null = null;
  aprInputFreq: number | null = null;
  aprInputNper: number | null = null;
  aprInputPmt: number | null = null;
  aprInputPv: number | null = null;
  initialDealCommission = 0;
  initialDrawCommission = 0;

  /** Debounce timer handle for amount-input recalculation (prevents mid-typing flicker). */
  private recalcTimer: any;

  private readonly COMMISSION_MAX_EACH = 6;
  private readonly COMMISSION_MAX_TOTAL = 10;

  dealSliderOptions: Options = {
    floor: 0,
    ceil: 6,
    step: 0.5,
    showTicks: true,
    showTicksValues: true,
    showSelectionBar: true,
  };
  drawSliderOptions: Options = {
    floor: 0,
    ceil: 6,
    step: 0.5,
    showTicks: true,
    showTicksValues: true,
    showSelectionBar: true,
  };

  // Hardcoded values for calculation
  private readonly PAYBACK_SINGLE = 1000; // Example value
  private readonly NUMBER_OF_DAYS_TO_REPAY = 140; // Example value
  private readonly LEGAL_EST_RECEIPTS = 5000; // Example value
  private readonly AVERAGE_DAYS = 21.6667;
  // dataSource;
  payNowRows: any;
  forminput = { term: '', factor: '' };
  offersObjLength = 0;
  defaultValue = 100;
  sliderOptions: Options = {
    floor: 0,
    ceil: 195313,
    step: 1,
    showTicks: true,
    showTicksValues: true,
    ticksArray: [0, 48850, 97700, 146550, 195313],
    ticksTooltip: (val: number): string => {
      return `$${val.toLocaleString('en-US')}`;
    },
    translate: (value: number, label: LabelType): string => {
      return '$' + value;
    }
  };
  @ViewChild('scheduleTable')
  scheduleTable!: ElementRef;
  invalidOppId: boolean = false;
  showImportantNote = false;
  floatingWindowActive: boolean = false;
  copyButtonText: string = 'Copy';
  showValidationError: boolean = false;
  validationErrorMessage: string = '';

  getDailyPayment(factor: any, term: any) {
    // this.startingBalance = this.amount * this.factor;
    // this.dailyPayment = this.startingBalance / this.term;
    // this.weeklyPayment = this.dailyPayment * 5;
    const startingBalanceLoc = (this.amount * factor).toFixed(2);
    return (parseFloat(startingBalanceLoc) / term);
  }

  getDailyPaymentBasedOnMaxLimit(maxLimit: any, factor: any, term: any) {
    const startingBalanceLoc = (maxLimit * factor).toFixed(2);
    return (parseFloat(startingBalanceLoc) / term);
  }

  rawOffersListObj = [];

  offersListObj: any[] = [];

  takeScreenshot() {
    console.log('Taking Screenshot');
  }

  selectedOptionIndex: any;
  selectedOptionClass = '';

  /**
   * Called on (ngModelChange) — updates rawAmount only, no clamping.
   * Allows the field to be temporarily empty or partial while the user is typing.
   */
  sanitizeAmount() {
    // Keep raw string in sync but do NOT clamp here — clamping happens on blur.
    this.rawAmount = this.amount != null ? this.amount.toString() : '';
  }

  /**
   * Called on (blur) — enforces min=1 rule once the user leaves the field.
   */
  enforceMinOnBlur() {
    const sanitizedValue = this.rawAmount.replace(/\D/g, '');
    const parsed = sanitizedValue ? parseInt(sanitizedValue, 10) : 0;
    // Clamp to minimum 1 (and max) only now that user is done editing
    this.amount = (!sanitizedValue || parsed < 1) ? 1 : parsed;
    this.rawAmount = this.amount.toString();
    const maxLimit = this.offersListObj[this.selectedOptionIndex]?.limit;
    if (maxLimit && this.amount > maxLimit) {
      this.amount = maxLimit;
      this.rawAmount = this.amount.toString();
    }
    if (!maxLimit && this.amount > 999999) {
      this.amount = 999999;
      this.rawAmount = this.amount.toString();
    }
    // Trigger recalculation now that we have a valid value
    const currentOffer = this.offersListObj[this.selectedOptionIndex];
    this.calcAndScrollToSchedule(currentOffer, this.selectedOptionIndex, false);
  }

  reCalcOfferDailyPayments() {
    // Do NOT clamp/sanitize here — that happens on blur via enforceMinOnBlur().
    // Only skip recalculation if the field is currently empty (mid-edit).
    const sanitizedValue = this.rawAmount?.replace(/\D/g, '');
    if (!sanitizedValue) return; // field is temporarily empty — wait for blur

    // Debounce the heavy recalculation so rapid typing only triggers one update
    clearTimeout(this.recalcTimer);
    this.recalcTimer = setTimeout(() => {
      const currentOffer = this.offersListObj[this.selectedOptionIndex];
      this.calcAndScrollToSchedule(currentOffer, this.selectedOptionIndex, false);
    }, 300);
  }

  calcAndScrollToSchedule(offerObj: any, optionNumber: any, scrollToSchedule = true, clickIndex: any = null) {
    // console.log(optionNumber.classList);
    this.showScheduleTable = true;
    if (this.isMerchantFlow && clickIndex !== null && this.selectedOptionIndex !== clickIndex) {
      this.onTabChanged({ index: clickIndex });
      this.selectedOptionIndex = clickIndex;
    } else {
      this.selectedOptionIndex = parseInt(optionNumber, 10);
    }
    if (scrollToSchedule) {
      console.log("Scrolling to schedule table" + this.selectedOptionIndex);
      this.scheduleTable.nativeElement.scrollIntoView({ behavior: 'smooth' });
    }
    this.term = parseInt(offerObj.term, 10);
    this.selectedOption = offerObj.collectionSchedule.toLowerCase() === 'daily' ? 'daily' : 'weekly';
    this.factor = parseFloat(offerObj.factor);
    this.selectedOptionClass = `selectedOption-${this.selectedOptionIndex}`;
    console.log("selectedOptionClass", this.selectedOptionClass);

    // ISO Commission Panel: reset sliders to defaults for this specific offer.
    // Also gates recalculateWithCommissions() (and calculateNominalAPR() inside it)
    // behind the feature flag — when off, always falls through to calculateTable().
    if (!this.isMerchantFacingMode && this.isIsoCommissionEnabled && offerObj.baseFactor !== undefined) {
      this.currentBaseFactor = offerObj.baseFactor;
      this.currentUpsellPoints = offerObj.upsellPoints ?? 2;
      this.dealCommission = this.pcntInitialLimit + (offerObj.upsellActivation || 0);
      this.drawCommission = this.pcntDraw + (offerObj.upsellDraw || 0);
      // Snapshot initial values so the Reset button knows when sliders have been modified
      this.initialDealCommission = this.dealCommission;
      this.initialDrawCommission = this.drawCommission;
      this.recalculateWithCommissions();
    } else {
      setTimeout(() => {
        this.calculateTable('');
      }, 0);
    }
  }

  /**
   * Recalculates sell rate (factor), payments, specified %, and APR when commission sliders change.
   * Called on slider change and on offer tab switch.
   */
  recalculateWithCommissions(): void {
    // Enforce per-slider (6%) and combined (10%) caps before any calculation
    this.updateCommissionCeilings();
    if (!this.amount || this.amount < 1) return; // prevent NaN when amount is 0 or empty

    // Sell rate formula (SF: Base_Factor__c + ((Upsell_Activation__c + Upsell_Draw__c) * Upsell_for_Points__c) / 100)
    // Upsell_Activation__c = dealCommission − pcntInitialLimit (raw upsell portion, ISO baseline excluded)
    // Upsell_Draw__c       = drawCommission − pcntDraw         (raw upsell portion, ISO baseline excluded)
    this.calculatedFactor = this.currentBaseFactor
      + ((this.dealCommission - this.pcntInitialLimit) + (this.drawCommission - this.pcntDraw)) * this.currentUpsellPoints / 100;

    this.factor = this.calculatedFactor;

    const offer = this.offersListObj[this.selectedOptionIndex];
    if (offer) {
      offer.factor = this.calculatedFactor;
      offer.dailyPayment = this.getDailyPaymentBasedOnMaxLimit(
        offer.limit ?? this.amount,
        this.calculatedFactor,
        offer.term
      );
      if (this.shouldShowEstAPR()) {
        this.calculatedAPR = this.calculateNominalAPR(this.amount, this.calculatedFactor, offer.term);
        if (this.calculatedAPR !== null) {
          offer.estAPR = this.calculatedAPR.toFixed(2) + '%';
        }
      }
    }

    setTimeout(() => {
      this.calculateTable('');
    }, 0);
  }

  /**
   * Intercepts the amount slider's valueChange event without writing back to this.amount.
   * The slider lives in a d-none container and is never visible. Its [(value)] two-way
   * binding was silently clamping this.amount to sliderOptions.ceil (195313) on every
   * change-detection cycle when the user typed a larger number, causing the input to
   * flicker between the typed value, the slider's ceil, and the offer limit on every
   * keystroke.  Switching to [value]-only (one-way) display and absorbing valueChange
   * here stops that feedback loop.
   */
  onAmountSliderValueChange(_val: number): void {
    // Intentionally no-op — do not write _val back to this.amount.
  }

  /** Whether the ISO commission panel and all its calculation paths are enabled. */
  get isIsoCommissionEnabled(): boolean {
    return FeatureFlags.isoCommissionPanelEnabled;
  }

  /** True on localhost, dev, and UAT — false on production. Used to gate debug/internal UI like the Calculation Breakdown. */
  get isDevOrUatEnv(): boolean {
    const h = window.location.hostname;
    return h.includes('uat') || h.includes('dev') || h.includes('local') || h === 'localhost';
  }

  /**
   * Enforces the per-slider max (6%) and the combined max (10%).
   * Each slider's ceil is updated dynamically so the thumb hard-stops at the
   * allowed position (e.g. Deal=6% → Draw slider stops at 4%).
   * Tick colors above the ceil are also shown in warning orange for clarity.
   */
  updateCommissionCeilings(): void {
    const dealCeil = Math.min(this.COMMISSION_MAX_EACH,
                              this.COMMISSION_MAX_TOTAL - this.drawCommission);
    const drawCeil = Math.min(this.COMMISSION_MAX_EACH,
                              this.COMMISSION_MAX_TOTAL - this.dealCommission);
    // Clamp values if they exceed the allowed combined limit (e.g. typed directly into the number input)
    if (this.dealCommission > dealCeil) { this.dealCommission = dealCeil; }
    if (this.drawCommission > drawCeil) { this.drawCommission = drawCeil; }
    // Update ceil so the slider thumb hard-stops at the dynamic boundary,
    // and color ticks above it orange to mark the restricted zone.
    // Requires new object references so ngx-slider detects the changes.
    this.dealSliderOptions = {
      ...this.dealSliderOptions,
      ceil: dealCeil,
      getTickColor: (value: number): string => value > dealCeil ? '#e8724a' : '',
    };
    this.drawSliderOptions = {
      ...this.drawSliderOptions,
      ceil: drawCeil,
      getTickColor: (value: number): string => value > drawCeil ? '#e8724a' : '',
    };
  }

  /** Width (%) of the active slider zone for the Deal slider (remaining is the dead zone). */
  get dealSliderWidthPct(): number {
    return (this.dealCommissionMax / this.COMMISSION_MAX_EACH) * 100;
  }

  /** Width (%) of the active slider zone for the Draw slider (remaining is the dead zone). */
  get drawSliderWidthPct(): number {
    return (this.drawCommissionMax / this.COMMISSION_MAX_EACH) * 100;
  }

  /** Dynamic max for the Deal Commission number input. */
  get dealCommissionMax(): number {
    return Math.min(this.COMMISSION_MAX_EACH,
                    this.COMMISSION_MAX_TOTAL - this.drawCommission);
  }

  /** Dynamic max for the Draw Commission number input. */
  get drawCommissionMax(): number {
    return Math.min(this.COMMISSION_MAX_EACH,
                    this.COMMISSION_MAX_TOTAL - this.dealCommission);
  }

  /** Running sum of both commissions — drives the combined total badge. */
  get combinedCommission(): number {
    return +(this.dealCommission + this.drawCommission).toFixed(2);
  }

  /** True when either slider differs from the initial value for the currently selected offer. */
  get isCommissionModified(): boolean {
    return this.dealCommission !== this.initialDealCommission
        || this.drawCommission !== this.initialDrawCommission;
  }

  /** Restores both sliders to the initial values for the selected offer and recalculates. */
  resetCommissions(): void {
    this.dealCommission = this.initialDealCommission;
    this.drawCommission = this.initialDrawCommission;
    this.recalculateWithCommissions();
  }

  /**
   * Calculates NOMINAL APR (not effective/compound) using Newton-Raphson rate iteration.
   * John confirmed: use nominal rate, not effective interest rate.
   */
  calculateNominalAPR(drawAmount: number, factor: number, term: number): number | null {
    try {
      const freq = this.selectedOption === 'weekly' ? 5 : 1;
      const nper = term / freq;
      const pmt  = (drawAmount * factor) / nper; // positive pmt (per Smeet/Salesforce convention)
      const pv   = -drawAmount;                  // negative pv

      // Store inputs for Calculation Breakdown display
      this.aprInputFreq = freq;
      this.aprInputNper = nper;
      this.aprInputPmt  = pmt;
      this.aprInputPv   = pv;

      const periodRate = (financial as any).rate(nper, pmt, pv, 0, 0, 0.1);
      this.calculatedPeriodRate = periodRate;
      return periodRate * (260 / freq) * 100;           // × 260 for daily (freq=1), × 52 for weekly (freq=5)
    } catch {
      this.calculatedPeriodRate = null;
      this.aprInputFreq = null;
      this.aprInputNper = null;
      this.aprInputPmt  = null;
      this.aprInputPv   = null;
      return null;
    }
  }

  onOptionChange(event: any) {
    console.log(event);
    const value = parseInt(event.target.value, 10) - 0;
    this.calcAndScrollToSchedule(this.offersListObj[this.selectedOptionIndex], this.selectedOptionIndex);
  }


  isChildOfferModalLoading = false; // Track loading state
  modalRef!: BsModalRef;
  openConfirmationDialog(offerObj: any, optionNumber: any) {
    // console.log(offerObj);
    // console.log(optionNumber);
    this.selectedOptionIndex = optionNumber;
    const rawOfferObj: any = this.rawOffersListObj[optionNumber];

    // For ISO mode: build the adjusted payload as per slack spec:
    //   upsellActivation = dealSlider − pcntInitialLimit  (the ISO's additional upsell only)
    //   upsellDraw       = drawSlider − pcntDraw
    //   factor           = calculated sell rate from sliders
    //   estAPR           = recalculated nominal APR (CA/NY only)
    // Gated behind the feature flag — when off, always sends the raw unmodified offer.
    const adjustedRawOffer: any = (!this.isMerchantFacingMode && this.isIsoCommissionEnabled && this.calculatedFactor > 0)
      ? {
        ...rawOfferObj,
        factor: +this.calculatedFactor.toFixed(4),
        upsellActivation: +(this.dealCommission - this.pcntInitialLimit).toFixed(4),
        upsellDraw: +(this.drawCommission - this.pcntDraw).toFixed(4),
        estAPR: this.calculatedAPR !== null
          ? +this.calculatedAPR.toFixed(2)
          : (rawOfferObj.estAPR != null ? +parseFloat(rawOfferObj.estAPR).toFixed(2) : rawOfferObj.estAPR),
      }
      : rawOfferObj;

    this.modalRef = this.modalService.show(PriceConfirmationComponent,
      {
        class: `modal-dialog-centered modal-lg offerConfirmationModal selectedOption-${this.selectedOptionIndex}`,
        backdrop: true,
        ignoreBackdropClick: true,
        keyboard: false,
        initialState: {
          offerData: offerObj,
          rawOfferObj: adjustedRawOffer,
          oppId: this.oppId,
          selectedOption: this.selectedOption,
          optionIndex: optionNumber,
          isLoanProductMode: this.isLoanProductMode,
          state: this.state
        }

      });

    // const modalInstance = this.modalRef.content as PriceConfirmationComponent;
    // if (modalInstance.loadingChange) {
    //   modalInstance.loadingChange.subscribe((loading: boolean) => {
    //     this.isChildOfferModalLoading = loading;
    //     // console.log(" this.isChildOfferModalLoading: " + this.isChildOfferModalLoading);
    //   });
    // }

    // this.modalRef.onHide.subscribe(() => {
    //   console.log("I am here onHide: " + this.isChildOfferModalLoading);
    //   if (this.isChildOfferModalLoading) {
    //     console.log("I am here onHideFunction: " + this.isChildOfferModalLoading);
    //     return false;
    //   }
    // });

  }

  captureScreenshot() {
    const element = document.getElementById('capture-pricing-cal-schedule'); // Replace with your element's ID

    if (element) {
      // Create a wrapper div with padding
      const wrapper = document.createElement('div');
      wrapper.classList.add('screenshot-wrapper');
      wrapper.style.padding = '20px'; // Add your desired padding
      wrapper.style.width = '1440px'; // Add your desired padding
      wrapper.style.backgroundColor = 'white'; // Optional: set background color
      wrapper.style.position = 'absolute'; // Prevent layout issues
      wrapper.style.left = '-9999px'; // Move it off-screen to avoid user interaction
      wrapper.appendChild(element.cloneNode(true) as HTMLElement); // Clone the target element

      document.body.appendChild(wrapper); // Add wrapper to DOM
      // Apply CSS to the input with class 'amount-input' to show in large font
      const amountInput = wrapper.querySelector('.amount-input') as HTMLElement;
      const dateInput = wrapper.querySelector('.pricing-startdate-input input') as HTMLElement;
      if (amountInput) {
        amountInput.style.fontSize = '22px'; // Set the desired large font size
        amountInput.style.paddingTop = '14px';
      }
      if (dateInput) {
        dateInput.style.fontSize = '22px'; // Set the desired large font size
        dateInput.style.paddingTop = '14px';
      }
      html2canvas(wrapper, {
        ignoreElements: (el) => el.classList.contains('capture-pricing-cal-schedule-exclude')
      }).then((canvas) => {
        // Convert the canvas to an image
        const image = canvas.toDataURL('image/png');
        // Remove the wrapper from DOM
        document.body.removeChild(wrapper);
        // Create a link to download the image
        const link = document.createElement('a');
        link.href = image;
        const optionNumber = this.selectedOptionIndex + 1;
        const selectedOffer = this.offersListObj[this.selectedOptionIndex];
        const totAmount = this.amount * selectedOffer.factor;
        const dailyAmount = (totAmount / selectedOffer.term).toFixed(2);
        const timestamp = new Date().toLocaleString('en-US', { hour12: false }).replace(',', '').replace(/\//g, '-').replace(/:/g, '-').replace(' ', '_');
        link.download = `Option${optionNumber}_${dailyAmount}_${timestamp}.png`;
        link.click();
      }).catch((error) => {
        console.error('Error capturing screenshot:', error);
        // Remove the wrapper from DOM
        document.body.removeChild(wrapper);
      });
    } else {
      console.error('Element not found!');
    }
  }

  displayedColumns: string[] = [
    'bizDays',
    'bizDate',
    'sumDallies',
    'pnb',
    'remainBal',
    'totalPaid',
    'totCostCap',
    'factor',
    'totSavings',
  ];

  constructor(public router: Router, private accountService: AccountService, private activatedRoute: ActivatedRoute, private modalService: BsModalService) { }

  /**
   * Determines the calculator mode based on the current domain/hostname (secondary priority)
   * @returns The calculator mode: default, merchant_flow, loan_product, or merchant_loan_product
   */
  private determineCalculatorMode(): 'default' | 'merchant_flow' | 'loan_product' | 'merchant_loan_product' {
    const hostname = window.location.hostname;
    const cleanHostname = hostname.split(':')[0]; // Remove port for local development

    // Merchant-facing loan product mode
    if (cleanHostname === 'loan-offers-local.revenued.com' ||
      cleanHostname === 'loan-offers-uat.revenued.com' ||
      cleanHostname === 'loan-offers.revenued.com' ||
      cleanHostname === 'loan-offers-local.revenuedva.com' ||
      cleanHostname === 'loan-offers-uat.revenuedva.com' ||
      cleanHostname === 'loan-offers.revenuedva.com') {
      return 'merchant_loan_product';
    }

    // Loan product mode
    if (cleanHostname === 'cf-offers-uat.revenued.com' ||
      cleanHostname === 'cf-offers.revenued.com' ||
      cleanHostname === 'cf-offers-local.revenued.com' ||
      cleanHostname === 'cf-offers-uat.revenuedva.com' ||
      cleanHostname === 'cf-offers.revenuedva.com' ||
      cleanHostname === 'cf-offers-local.revenuedva.com') {
      return 'loan_product';
    }

    // Existing merchant flow mode
    if (cleanHostname === 'offers-uat.revenued.com' ||
      cleanHostname === 'offers.revenued.com' ||
      cleanHostname === 'offers-local.revenued.com' ||
      cleanHostname === 'offers-uat.revenuedva.com' ||
      cleanHostname === 'offers.revenuedva.com' ||
      cleanHostname === 'offers-local.revenuedva.com') {
      return 'merchant_flow';
    }

    // Default mode
    return 'default';
  }

  /**
   * Determines the final calculator mode with primary and secondary priority logic
   * @param productType - The product type from API response
   * @returns The final calculator mode
   */
  private determineFinalCalculatorMode(productType?: string): 'default' | 'merchant_flow' | 'loan_product' | 'merchant_loan_product' {
    // PRIMARY CONDITION: If productType is 'CreditFacility', force loan product mode
    if (productType === 'CreditFacility') {
      // Analyze current context to distinguish between loan_product and merchant_loan_product
      const secondaryMode = this.determineCalculatorMode();

      // If secondary determination suggests merchant-facing, use merchant_loan_product
      if (secondaryMode === 'merchant_flow' || secondaryMode === 'merchant_loan_product') {
        return 'merchant_loan_product';
      }

      // Otherwise, use standard loan_product mode
      return 'loan_product';
    }

    // SECONDARY PRIORITY: Use domain-based determination for other product types
    return this.determineCalculatorMode();
  }

  /**
   * Checks if the current mode is any loan product mode
   */
  get isLoanProductMode(): boolean {
    return this.calculatorMode === 'loan_product' || this.calculatorMode === 'merchant_loan_product';
  }

  /**
   * Checks if the current mode is merchant-facing (either regular or loan product)
   */
  get isMerchantFacingMode(): boolean {
    return this.calculatorMode === 'merchant_flow' || this.calculatorMode === 'merchant_loan_product';
  }

  /**
 * Gets the appropriate text for "Available spending limit" based on mode
 */
  getDescriptionText(): string {
    return this.isLoanProductMode ? 'Select from following options or enter loan amount' : 'Select from following options or enter draw amount';
  }

  /**
   * Gets the appropriate text for "Available spending limit" based on mode
   */
  getAvailableSpendingLimitText(): string {
    return this.isLoanProductMode ? 'Available Limit' : 'Available Spending Limit';
  }


  /**
  * Gets the appropriate text for "Estimated APR" based on mode
  */
  getEstdAPRText(): string {
    return this.isLoanProductMode ? 'Repayment per $1' : 'Estimated APR';
  }

  /**
   * Checks if Estimated APR should be shown based on state
   */
  shouldShowEstAPR(): boolean {
    const isNYorCA = /^(ny|new york|ca|california)$/i.test(this.state?.trim() || '');
    const isMCard = this.productType === 'MCard';
    return isNYorCA && isMCard;
  }


  /**
   * Gets the appropriate text for "Factor" based on mode
   */
  getFactorText(): string {
    if (this.isLoanProductMode || this.shouldShowEstAPR()) return 'Repayment per $1';
    return 'Factor Rate';
  }

  /**
   * Gets the appropriate text for "Estimated payback period" based on mode
   */
  getPaybackPeriodText(): string {
    return this.isLoanProductMode ? 'Repayment period' : 'Estimated Payback Period';
  }

  /**
   * Gets the appropriate text for "Estimated daily payment" based on mode
   */
  getDailyPaymentText(): string {
    if (this.isLoanProductMode) {
      return this.selectedOption === 'daily' ? 'Daily payment' : 'Weekly payment';
    }
    return this.selectedOption === 'daily' ? 'Estimated Daily Payment' : 'Estimated Weekly Payment';
  }

  /**
   * Gets the appropriate text for "Draw amount" based on mode
   */
  getDrawAmountText(): string {
    return this.isLoanProductMode ? 'Loan Amount ($)' : 'Draw Amount ($)';
  }

  /**
   * Gets the appropriate text for "Estimated purchase amount" based on mode
   */
  getPurchaseAmountText(): string {
    return this.isLoanProductMode ? 'Total Repayment Amount' : 'Estimated Purchased Amount';
  }

  /**
   * Gets the appropriate text for "Total cost of capital" based on mode
   */
  getTotalCostCapitalText(): string {
    return this.isLoanProductMode ? 'Total Cost of Debt' : 'Total Cost of Capital';
  }

  /**
   * Transforms "draw" to "loan" in text for loan product mode
   */
  transformDrawToLoan(text: string): string {
    if (!this.isLoanProductMode) {
      return text;
    }
    return text.replace(/\bdraw\b/gi, 'Loan');
  }

  /**
   * Checks if specified percentage field should be hidden
   */
  get shouldHideSpecifiedPercentage(): boolean {
    return this.isLoanProductMode;
  }

  /**
   * Validates product type against current URL mode
   * @param productType - The product type from API response
   * @returns Object with validation result and error message if invalid
   */
  private validateProductTypeAndUrlMode(productType?: string): { isValid: boolean; errorMessage: string } {
    const currentMode = this.determineCalculatorMode();
    const isLoanModeUrl = currentMode === 'loan_product' || currentMode === 'merchant_loan_product';

    // Validation Rule 1: If product type === "MCard" AND user is on loan mode URL → Invalid combination
    if (productType === 'MCard' && isLoanModeUrl) {
      return {
        isValid: false,
        errorMessage: 'The link is invalid. Please contact your sales rep.'
      };
    }

    // Validation Rule 2: If product type !== "MCard" AND user is on non-loan mode URL → Invalid combination
    if (productType !== 'MCard' && !isLoanModeUrl) {
      return {
        isValid: false,
        errorMessage: 'The link is invalid. Please contact your sales rep.'
      };
    }

    return {
      isValid: true,
      errorMessage: ''
    };
  }

  /**
   * Checks if tooltip should be shown for payback period
   */
  get shouldShowPaybackPeriodTooltip(): boolean {
    return !this.isLoanProductMode;
  }

  /**
   * Test method to verify validation logic (for development/debugging)
   * This method can be called from browser console for testing
   */
  testValidationLogic(): void {
    const testCases = [
      { productType: 'MCard', description: 'MCard on loan mode URLs (should be invalid)' },
      { productType: 'MCard', description: 'MCard on non-loan mode URLs (should be valid)' },
      { productType: 'CreditFacility', description: 'CreditFacility on loan mode URLs (should be valid)' },
      { productType: 'CreditFacility', description: 'CreditFacility on non-loan mode URLs (should be invalid)' },
      { productType: 'StandardProduct', description: 'StandardProduct on loan mode URLs (should be invalid)' },
      { productType: 'StandardProduct', description: 'StandardProduct on non-loan mode URLs (should be valid)' },
      { productType: undefined, description: 'Undefined product type on loan mode URLs (should be invalid)' },
      { productType: undefined, description: 'Undefined product type on non-loan mode URLs (should be valid)' }
    ];

    const testDomains = [
      { domain: 'loan-offers-uat.revenued.com', isLoanMode: true },
      { domain: 'cf-offers-uat.revenued.com', isLoanMode: true },
      { domain: 'offers-uat.revenued.com', isLoanMode: false },
      { domain: 'app.revenued.com', isLoanMode: false }
    ];

    console.log('=== Validation Logic Test Results ===');
    console.log('Current hostname:', window.location.hostname);

    testDomains.forEach(({ domain, isLoanMode }) => {
      console.log(`\n--- Testing on ${domain} (Loan Mode: ${isLoanMode}) ---`);

      // Temporarily override hostname for testing
      const originalHostname = window.location.hostname;
      Object.defineProperty(window.location, 'hostname', {
        writable: true,
        value: domain
      });

      testCases.forEach(({ productType, description }) => {
        const validationResult = this.validateProductTypeAndUrlMode(productType);
        const expectedValid = (productType === 'MCard' && !isLoanMode) ||
          (productType !== 'MCard' && isLoanMode);
        const status = validationResult.isValid === expectedValid ? '✅ PASS' : '❌ FAIL';
        console.log(`${status} ${productType || 'undefined'}: ${validationResult.isValid ? 'Valid' : 'Invalid'} - ${description}`);
        if (!validationResult.isValid) {
          console.log(`   Error: ${validationResult.errorMessage}`);
        }
      });

      // Restore original hostname
      Object.defineProperty(window.location, 'hostname', {
        writable: true,
        value: originalHostname
      });
    });
  }

  /**
   * Test method to verify mode detection logic (for development/debugging)
   * This method can be called from browser console for testing
   */
  testModeDetection(): void {
    const testDomains = [
      'loan-offers-local.revenued.com',
      'loan-offers-uat.revenued.com',
      'loan-offers.revenued.com',
      'loan-offers-local.revenuedva.com',
      'loan-offers-uat.revenuedva.com',
      'loan-offers.revenuedva.com',
      'cf-offers-uat.revenued.com',
      'cf-offers.revenued.com',
      'cf-offers-local.revenued.com',
      'cf-offers-uat.revenuedva.com',
      'cf-offers.revenuedva.com',
      'cf-offers-local.revenuedva.com',
      'offers-uat.revenued.com',
      'offers.revenued.com',
      'offers-local.revenued.com',
      'offers-uat.revenuedva.com',
      'offers.revenuedva.com',
      'offers-local.revenuedva.com',
      'app.revenued.com',
      'localhost:4200'
    ];

    const testProductTypes = ['CreditFacility', 'StandardProduct', undefined];

    console.log('=== Mode Detection Test Results ===');
    console.log('Current hostname:', window.location.hostname);
    console.log('Current mode:', this.calculatorMode);
    console.log('Is loan product mode:', this.isLoanProductMode);
    console.log('Is merchant facing mode:', this.isMerchantFacingMode);

    console.log('\n=== Secondary Priority (Domain-based) Results ===');
    testDomains.forEach(domain => {
      // Temporarily override hostname for testing
      const originalHostname = window.location.hostname;
      Object.defineProperty(window.location, 'hostname', {
        writable: true,
        value: domain
      });

      const mode = this.determineCalculatorMode();
      console.log(`${domain} -> ${mode}`);

      // Restore original hostname
      Object.defineProperty(window.location, 'hostname', {
        writable: true,
        value: originalHostname
      });
    });

    console.log('\n=== Primary + Secondary Priority (Product Type + Domain) Results ===');
    testDomains.forEach(domain => {
      testProductTypes.forEach(productType => {
        // Temporarily override hostname for testing
        const originalHostname = window.location.hostname;
        Object.defineProperty(window.location, 'hostname', {
          writable: true,
          value: domain
        });

        const finalMode = this.determineFinalCalculatorMode(productType);
        console.log(`${domain} + ${productType || 'undefined'} -> ${finalMode}`);

        // Restore original hostname
        Object.defineProperty(window.location, 'hostname', {
          writable: true,
          value: originalHostname
        });
      });
    });
  }


  checkOfferCount(offersCount: number) {
    console.log("I am here Offers count: " + offersCount);
    setTimeout(() => {
      let selectedOfferTab = document.querySelector('.offersGridParentWrapper4 mat-tab-header') as HTMLElement;
      let selectedOfferTabContent = document.querySelector('.offersGridParentWrapper4 .tabContentWrapper') as HTMLElement;
      let selectedOfferItem = document.querySelector('.offersGridParentWrapper4 .offersGridWrapper') as HTMLElement;
      if (offersCount == 1) {
        // console.log("I am here 2");
        selectedOfferTab?.classList?.add?.('singleOfferTab');
        selectedOfferTabContent?.classList?.add?.('singleOfferTabContent');
        selectedOfferItem?.classList?.remove?.('dualOffers');
        selectedOfferItem?.classList?.remove?.('multiOffers');
        selectedOfferItem?.classList?.add?.('singleOffer');
      }
      else if (offersCount == 2) {
        selectedOfferTab?.classList?.remove?.('singleOfferTab');
        selectedOfferTabContent?.classList?.remove?.('singleOfferTabContent');
        selectedOfferItem?.classList?.add?.('dualOffers');
        selectedOfferItem?.classList?.remove?.('singleOffer');
        selectedOfferItem?.classList?.remove?.('multiOffers');
      }
      else {
        // console.log("I am here 3");
        // console.log("I am here Offers count: " + offersCount);
        // console.log("I am here selectedOfferItem: " + selectedOfferItem);
        selectedOfferTab?.classList?.remove?.('singleOfferTab');
        selectedOfferTabContent?.classList?.remove?.('singleOfferTabContent');
        selectedOfferItem?.classList?.add?.('multiOffers');
        selectedOfferItem?.classList?.remove?.('singleOffer');
        selectedOfferItem?.classList?.remove?.('dualOffers');
      }
    }, 0);
  }

  ngOnInit(): void {
    let oppId = '';
    this.activatedRoute.queryParams.subscribe(
      (params: any) => {
        if (!params || !params.oppId) {
          this.invalidOppId = true;
        }
        oppId = params.oppId;
        this.oppId = oppId;
        this.isOnlineCheckout = params.isOnlineCheckout === '1';
      }
    );

    // Initial mode determination (will be updated after API response)
    this.calculatorMode = this.determineCalculatorMode();
    this.isMerchantFlow = this.isMerchantFacingMode;
    this.selectedOption = 'daily';
    this.graceWindow = localStorage.getItem('Grace_Window_Days') ? parseInt(localStorage.getItem('Grace_Window_Days') || '22', 10) : 22;
    this.postGracePremium = localStorage.getItem('Post_Grace_Premium') ? parseFloat(localStorage.getItem('Post_Grace_Premium') || '1.085') : 1.085;

    const getTermAndFactor = (this.isMerchantFlow || this.isOnlineCheckout) ? this.accountService.getDirectMerchantTermAndFactor(oppId) : this.accountService.getTermAndFactorDirect(oppId);
    // let oldTerm = !localStorage.getItem("prepayCalTerm") ? null : parseInt(localStorage.getItem("prepayCalTerm"));
    // let oldFactor = !localStorage.getItem("prepayCalFactor") ? null : parseFloat(localStorage.getItem("prepayCalFactor"));
    // let oldAmount = !localStorage.getItem("prepayCalAmount") ? null : parseFloat(localStorage.getItem("prepayCalAmount"));
    // if (!localStorage.getItem('collSchedType') || !oldFactor || !oldTerm) {
    getTermAndFactor.subscribe((res) => {
      res = JSON.parse(res);
      this.term = parseInt(res.term, 10);
      const productType = res.productType; // CreditFacility
      this.productType = productType;

      // VALIDATION: Check product type against URL mode before proceeding
      const validationResult = this.validateProductTypeAndUrlMode(productType);
      console.log('Validation Result:', validationResult);
      console.log('Product Type:', productType);
      console.log('Current URL Mode:', this.determineCalculatorMode());

      if (!validationResult.isValid) {
        console.warn('Validation failed - showing error message');
        this.showValidationError = true;
        this.validationErrorMessage = validationResult.errorMessage;
        this.loadingOffers = false;
        return; // Early return to prevent normal page loading
      }

      // APPLY CONDITIONAL LOGIC: Determine final calculator mode based on product type
      this.calculatorMode = this.determineFinalCalculatorMode(productType);
      this.isMerchantFlow = this.isMerchantFacingMode; // Update backward compatibility flag

      console.log('Product Type:', productType);
      console.log('Final Calculator Mode:', this.calculatorMode);
      console.log('Is Loan Product Mode:', this.isLoanProductMode);
      console.log('Is Merchant Facing Mode:', this.isMerchantFacingMode);

      this.selectedOption = res.collSchedType ? res.collSchedType?.toLowerCase() : 'daily';
      this.factor = parseFloat(res.factor);
      this.showFinancialsMsg = res?.showFinancialsMsg
      this.avgDailyRev = res?.avgDailyRev;
      this.busName = res?.busName || '';
      this.noDrawComm = res?.noDrawComm === true;
      this.amount = 1000; // always start at $1,000 per product decision
      this.disableCalc = res.funded === true;
      this.offerAccepted = res.accepted === true;
      this.rawOffersListObj = res?.offers;
      this.legalEstRct = res.legalEstRct;
      this.state = res.state;
      this.offersListObj = res?.offers ? res.offers.map((offer: any, index: number) => ({
        favIcon: 'https://www.revenued.com/hubfs/raw_assets/public/Revenued%20-%202024/img/icons/favicon/Favicon_32x32.png',
        logoUrl: '../../../assets/new-dash/logo/revenuedLogo.svg',
        logoUrlDark: '../../../assets/new-dash/logo/revenuedLogo_black.svg',
        offerId: offer.offerId,
        labelName: `Option ${index + 1}`,
        type: 'Standard',
        status: offer.status,
        statusText: offer.statusText,
        specifiedPnt: offer.specifiedPnt,
        limit: offer.maxLimit ? parseFloat(offer.maxLimit) : 999999,
        estAPR: offer.estAPR ? parseFloat(offer.estAPR).toFixed(2) + '%' : null,
        factor: parseFloat(offer.factor),
        term: parseInt(offer.term, 10),
        collectionSchedule: this.selectedOption,
        purchasedAmount: this.amount,
        dailyPayment: this.getDailyPaymentBasedOnMaxLimit(parseFloat(offer.maxLimit), parseFloat(offer.factor), parseInt(offer.term, 10)),
        scheduleLink: 'https://www.google.com'
      })) : [];

      if (this.isOnlineCheckout) {
        this.offersListObj = this.offersListObj.filter((offer: any) => offer.status === "Offer Accepted");
        this.specifiedPercentage = this.offersListObj[0]?.specifiedPnt;
      }

      // ISO Commission Panel: parse ISO-level fields and derive baseFactor per offer
      // Gated behind FeatureFlags.isoCommissionPanelEnabled — skipped when panel is off,
      // so pcntInitialLimit/pcntDraw stay 0 and offersListObj carries no commission metadata.
      if (!this.isMerchantFacingMode && this.isIsoCommissionEnabled) {
        this.pcntInitialLimit = parseFloat(res.pcntInitialLimit) || 0;
        this.pcntDraw = parseFloat(res.pcntDraw) || 0;
        this.offersListObj = this.offersListObj.map((offer: any, i: number) => {
          const raw = this.rawOffersListObj[i] as any;
          const upsellAct = parseFloat(raw?.upsellActivation) || 0;
          const upsellDrw = parseFloat(raw?.upsellDraw) || 0;
          const upsellPts = parseFloat(raw?.upsellPoints) || 2;
          // Use baseFactor directly from API response (no longer derived)
          const baseFactor = parseFloat(raw?.baseFactor) || offer.factor;
          return { ...offer, upsellActivation: upsellAct, upsellDraw: upsellDrw, upsellPoints: upsellPts, baseFactor };
        });
      }

      // Validation: Check if NY/CA state with MCard product type has any offer with missing estAPR
      const isNYorCA = /^(ny|new york|ca|california)$/i.test(this.state?.trim() || '');
      const isMCard = productType === 'MCard';
      const isBlankState = !this.state || this.state.trim() === '';
      const hasMissingEstAPR = this.offersListObj.some(offer =>
        !offer.estAPR || offer.estAPR === null || offer.estAPR === 'null%' || offer.estAPR === '0%' || offer.estAPR === 0
      );

      if ((isNYorCA && isMCard && hasMissingEstAPR) || (isBlankState && isMCard)) {
        this.showValidationError = true;
        this.validationErrorMessage = `We're experiencing an issue displaying your offers. Please contact your sales representative.`;
        this.loadingOffers = false;
        return;
      }

      this.showImportantNote = res?.showFinancialsMsg && this.offersListObj.some(offer => offer.limit >= 150000);
      this.floatingWindowActive = this.isLoanProductMode && !this.isMerchantFacingMode && this.offersListObj?.length > 0;
      // console.log("showImportantNote:" + this.showImportantNote);

      // Offer 4 details
      // this.offersListObj.push({
      //   favIcon: '../../../assets/new-dash/logo/pearlCapitalFavicon-120x120.png',
      //   logoUrl: '../../../assets/new-dash/logo/pearlCapital_white.svg',
      //   logoUrlDark: '../../../assets/new-dash/logo/pearlCapital_black.svg',
      //   offerId: 'a3AcW0000003TyLUAZ',
      //   labelName: 'Option 4',
      //   type: 'Standard',
      //   limit: 231100,
      //   factor: 1.39,
      //   term: 140,
      //   collectionSchedule: 'daily',
      //   purchasedAmount: 112200,
      //   dailyPayment: 1855.3333333333333,
      //   scheduleLink: 'https://www.google.com'
      // });
      // console.log('Offers List Object:', this.offersListObj);

      this.graceWindow = res.daysGrace;
      this.postGracePremium = parseFloat(res.postPremium);
      if (this.offersListObj?.[0]) {
        this.calcAndScrollToSchedule(this.offersListObj[0], 0, false);
      }
      this.loadingOffers = false;
      this.offersObjLength = this.offersListObj.length;
      console.log("I am in ngInit: Offers count: " + this.offersObjLength);
      this.checkOfferCount(this.offersObjLength);
      // localStorage.setItem("prepayCalTerm", this.term);
      // localStorage.setItem("collSchedType", this.selectedOption);
      // localStorage.setItem("prepayCalFactor", this.factor);
    }, (error) => {
      this.term = 140;
      this.factor = 1.39;
      // localStorage.setItem("prepayCalTerm", this.term);
      // localStorage.setItem("collSchedType", this.selectedOption);
      // localStorage.setItem("prepayCalFactor", this.factor);
    });
    // } else {
    //   this.term = oldTerm;
    //   this.factor = oldFactor;
    //   if (oldAmount) {
    //     this.amount = oldAmount;
    //     this.selectedDate = !localStorage.getItem("prepayCalDate") ? new Date() : new Date(localStorage.getItem("prepayCalDate"));
    //     setTimeout(() => {
    //       this.calculateTable("");
    //     }, 0);
    //   }
    // }

  }

  ngAfterViewInit() {
    this.checkOfferCount(this.offersObjLength);
  }

  graceWindow = 22;
  repoBase = 1;
  postGraceRepoBase = 1;
  postGracePremium = 1.085;
  holidayList: any;

  calculateTable(filterValue: string): void {
    if (
      this.term &&
      this.factor &&
      this.amount &&
      !isNaN(this.term) &&
      !isNaN(this.factor) &&
      !isNaN(this.amount) &&
      this.term > 0 &&
      this.factor > 0 &&
      this.amount > 0 &&
      this.selectedDate
    ) {
      console.log(this.term);
      console.log(this.factor);
      console.log(this.amount);
      // localStorage.setItem("prepayCalAmount", this.amount);
      // localStorage.setItem("prepayCalDate", moment(this.selectedDate).toString());
      this.repoBase = 1 / this.factor;
      this.postGraceRepoBase = this.postGracePremium / this.factor;

      console.log(this.repoBase);
      var dayIncrement = 5;
      this.startingBalance = this.amount * this.factor;
      this.dailyPayment = this.startingBalance / this.term;
      this.weeklyPayment = this.dailyPayment * 5;
      if (this.legalEstRct && this.isOnlineCheckout && this.isMerchantFlow) {
        this.specifiedPercentage = (this.dailyPayment / (this.legalEstRct / 21.6667)) * 100
      } else if (this.avgDailyRev && !this.isOnlineCheckout) {
        try {
          this.specifiedPercentage = (this.dailyPayment / (this.avgDailyRev / 21.6667)) * 100
        } catch (error) {
          this.specifiedPercentage = 0;
          console.log(error);
        }
      }

      payNowRows = [];

      for (let i = 5; i <= this.term; i += 5) {
        console.log('push');
        const dailyTally = i * this.dailyPayment;
        const remainBal = this.startingBalance - dailyTally;
        const payNow =
          i > this.graceWindow ? remainBal * this.postGraceRepoBase : remainBal * this.repoBase;
        const totalPaid = payNow + dailyTally;
        const totalCostCapital = totalPaid - this.amount;
        const totalSavings = remainBal - payNow;
        payNowRows.push({
          days: i,
          date: moment(this.selectedDate).businessAdd(i).toString(),
          sumOfDallies: dailyTally,
          remainingBalance: remainBal,
          payNowBalance: payNow,
          totalPaid,
          weeksUntilPayNow: 1,
          totalCostCapital,
          totalSavings,
          factor: (1 + totalCostCapital / this.amount).toFixed(2),
        });
      }
      this.payNowRows = [...payNowRows];
    } else {
      this.payNowRows = [];
    }
  }

  onTabChanged(e: any) {
    this.checkOfferCount(this.offersObjLength);
    console.log(e);
    if (this.offersListObj[e.index]?.limit && this.amount > this.offersListObj[e.index]?.limit) {
      this.amount = this.offersListObj[e.index]?.limit;
    }
    this.calcAndScrollToSchedule(this.offersListObj[e.index], e.index, false);

    if (window.innerWidth < 768) {
      const offerGridItemSelected = document.querySelector('#offerGridItem' + e.index) as HTMLElement;
      offerGridItemSelected.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });

    }
  }

  goToCashDraw() {
    this.router.navigate(['/dashboard/request-cash-draw']);
  }

  getUnderstandYourPricingUrl() {
    const hostname = window.location.hostname;
    const isRevenuedVA = hostname.includes('revenuedva.com');

    if (hostname.includes('uat') || hostname.includes('dev') || hostname.includes('local')) {
      return isRevenuedVA ? 'https://app-uat.revenuedva.com/dashboard/understand-your-pricing' : 'https://app-uat.revenued.com/dashboard/understand-your-pricing';
    } else {
      return isRevenuedVA ? 'https://app.revenuedva.com/dashboard/understand-your-pricing' : 'https://app.revenued.com/dashboard/understand-your-pricing';
    }
  }

  getPayNowUrl() {
    const hostname = window.location.hostname;
    const isRevenuedVA = hostname.includes('revenuedva.com');

    if (hostname.includes('uat') || hostname.includes('dev') || hostname.includes('local')) {
      return isRevenuedVA ? 'https://app-uat.revenued.com/dashboard/request-paynow' : 'https://app-uat.revenued.com/dashboard/request-paynow';
    } else {
      return isRevenuedVA ? 'https://app.revenued.com/dashboard/request-paynow' : 'https://app.revenued.com/dashboard/request-paynow';
    }
  }
  onOptionChanged(event: any) {
    this.selectedOption = event.value;
  }

  weekendsDatesFilter = (d: Date): boolean => {
    /* Prevent Saturday and Sunday for select. */
    return (
      d && moment(d).isBusinessDay() && !this.holidayList.find((h: any) => moment(d).isSame(moment(h)))
    );
  };

  disablePastDates = (current: Date): boolean => {
    // Disable all dates before today
    return current && current.getTime() < new Date().setHours(0, 0, 0, 0);
  };

  // Function to show a temporary tooltip for some seconds
  showTemporaryTooltip(tooltip: any) {
    tooltip.show();
    setTimeout(() => tooltip.hide(), 5000);
  }

  /**
   * Generate the merchant friendly link with the correct domain and oppId
   */
  getMerchantFriendlyLink(): string {
    if (!this.oppId) {
      return '';
    }

    const hostname = window.location.hostname;
    let baseUrl = 'https://loan-offers.revenued.com';

    // Determine the correct domain based on current hostname
    if (hostname.includes('revenuedva.com')) {
      if (hostname.includes('uat') || hostname.includes('dev') || hostname.includes('local')) {
        baseUrl = 'https://loan-offers-uat.revenuedva.com';
      } else {
        baseUrl = 'https://loan-offers.revenuedva.com';
      }
    } else {
      if (hostname.includes('uat') || hostname.includes('dev') || hostname.includes('local')) {
        baseUrl = 'https://loan-offers-uat.revenued.com';
      } else {
        baseUrl = 'https://loan-offers.revenued.com';
      }
    }

    return `${baseUrl}/pricing?oppId=${this.oppId}`;
  }

  /**
   * Copy the merchant friendly link to clipboard
   */
  async copyLinkToClipboard(): Promise<void> {
    try {
      const link = this.getMerchantFriendlyLink();
      await navigator.clipboard.writeText(link);

      // Provide visual feedback
      this.copyButtonText = 'Copied!';
      setTimeout(() => {
        this.copyButtonText = 'Copy';
      }, 2000);

      console.log('Link copied to clipboard:', link);
    } catch (error) {
      console.error('Failed to copy link to clipboard:', error);

      // Fallback method for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = this.getMerchantFriendlyLink();
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        // Provide visual feedback for fallback method too
        this.copyButtonText = 'Copied!';
        setTimeout(() => {
          this.copyButtonText = 'Copy';
        }, 2000);
        console.log('Link copied to clipboard (fallback method)');
      } catch (fallbackError) {
        console.error('Fallback copy method also failed:', fallbackError);
        this.copyButtonText = 'Failed';
        setTimeout(() => {
          this.copyButtonText = 'Copy';
        }, 2000);
      }
      document.body.removeChild(textArea);
    }
  }
}
